/* src/app/views/template/components/edit-template-menu/edit-template-spotlight-menu/edit-template-spotlight-menu-footer/edit-template-spotlight-menu-footer.component.scss */
/*# sourceMappingURL=edit-template-spotlight-menu-footer.component.css.map */
